import { OrderSavedSearch } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order/saved-search';

export class OrderSavedSearchController extends BaseHttpController {
  constructor() {
    super(endpoint, { useSelectedDomainContext: true });
  }

  async findAllGlobal(): Promise<OrderSavedSearch[]> {
    const response = await this.http.get<OrderSavedSearch[]>('global');
    return response.data.map(
      (val) => new OrderSavedSearch({ ...val, isPopularSearch: true }),
    );
  }

  async findAllForUser(): Promise<OrderSavedSearch[]> {
    const response = await this.http.get<OrderSavedSearch[]>('');
    return response.data.map((val) => new OrderSavedSearch(val));
  }

  async create(orderSavedSearch: OrderSavedSearch): Promise<OrderSavedSearch> {
    if (orderSavedSearch.id != null) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<OrderSavedSearch>('', {
      orderSavedSearch,
    });
    return new OrderSavedSearch(response.data);
  }

  async update(orderSavedSearch: OrderSavedSearch): Promise<OrderSavedSearch> {
    if (orderSavedSearch.id === undefined) {
      throw new Error('Id expected to be defined when calling update');
    }

    const response = await this.http.put<OrderSavedSearch>('', {
      orderSavedSearch,
    });
    return new OrderSavedSearch(response.data);
  }

  async delete(searchId: number): Promise<void> {
    await this.http.delete<void>(`${searchId}`);
  }
}
